import React from 'react';
import { CATEGORIES, rand } from './financeApi';
import { MoneyFlow } from './MoneyFlow';

const LABELS = { month: 'This month', quarter: 'This quarter', six_months: 'Last 6 months', year: 'This year', last_year: 'Past year' };

export const ReportsPanel = ({ reports }) => {
  if (!reports) return null;
  const max = Math.max(1, ...reports.monthly.map((m) => Math.max(m.total, m.income || 0)));
  return (
    <section className="space-y-4" data-testid="finance-reports">
      <MoneyFlow reports={reports} />
      <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
        {Object.entries(reports.periods).map(([key, p]) => (
          <div key={key} className={`rounded-2xl border p-4 bg-white ${key === 'month' ? 'border-emerald-300 ring-1 ring-emerald-200' : ''}`} data-testid={`report-${key}`}>
            <p className="text-xs uppercase tracking-wide text-muted-foreground">{LABELS[key]}</p>
            <p className="text-sm text-emerald-700 mt-1" data-testid={`report-${key}-income`}>In: <strong>{rand(p.income)}</strong></p>
            <p className="text-xl sm:text-2xl font-heading font-bold" data-testid={`report-${key}-total`}>{rand(p.total)}</p>
            <p className="text-xs text-muted-foreground">{p.count} expense(s)</p>
            <div className="mt-2 space-y-0.5">
              {CATEGORIES.map((c) => p.by_category[c.value] > 0 && (
                <p key={c.value} className="text-xs flex justify-between"><span>{c.label}</span><span className="font-medium">{rand(p.by_category[c.value])}</span></p>
              ))}
            </div>
            <p className={`text-xs mt-2 pt-2 border-t font-semibold ${p.left < 0 ? 'text-red-700' : ''}`} data-testid={`report-${key}-left`}>Left: {rand(p.left)}</p>
          </div>
        ))}
      </div>
      <div className="rounded-2xl border bg-white p-4">
        <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
          <p className="text-sm font-semibold">Money in vs expenses (last 12 months)</p>
          <p className="text-xs flex gap-3"><span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-emerald-500" /> Money in</span><span className="flex items-center gap-1"><span className="w-3 h-3 rounded-sm bg-amber-400" /> Expenses</span></p>
        </div>
        <div className="flex items-end gap-1 sm:gap-2 h-40" data-testid="report-monthly-chart">
          {reports.monthly.map((m) => (
            <div key={m.month} className="flex-1 flex flex-col items-center justify-end h-full" title={`${m.label}: in ${rand(m.income)}, out ${rand(m.total)}`}>
              <div className="w-full flex items-end justify-center gap-0.5 h-full">
                <div className="w-1/2 rounded-t-md bg-emerald-500 transition-[height] duration-500" style={{ height: `${((m.income || 0) / max) * 100}%`, minHeight: m.income ? 4 : 1 }} />
                <div className="w-1/2 rounded-t-md bg-amber-400 transition-[height] duration-500" style={{ height: `${(m.total / max) * 100}%`, minHeight: m.total ? 4 : 1 }} />
              </div>
              <span className="text-[10px] text-muted-foreground mt-1">{m.label.slice(0, 3)}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
